import { Phone, Calendar } from "lucide-react";

const MobileStickyBar = () => {
  const scrollToContact = () => {
    const element = document.querySelector("#kontakt");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div 
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-komel-neutral-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]"
      data-testid="mobile-sticky-bar"
    >
      <div className="grid grid-cols-2 divide-x divide-komel-neutral-200">
        {/* Anrufen Button */}
        <a
          href="tel:+41712261199"
          className="flex items-center justify-center gap-3 py-4 px-4 text-komel-primary hover:bg-komel-neutral-100 active:bg-komel-neutral-200 transition-colors"
          data-testid="sticky-call-button"
        >
          <div className="w-10 h-10 bg-komel-primary rounded-full flex items-center justify-center">
            <Phone className="w-5 h-5 text-white" />
          </div>
          <span className="font-semibold text-sm">Anrufen</span>
        </a>

        {/* Termin vereinbaren Button */}
        <button
          onClick={scrollToContact}
          className="flex items-center justify-center gap-3 py-4 px-4 bg-komel-accent text-white hover:bg-komel-accent-hover active:bg-komel-accent-hover transition-colors"
          data-testid="sticky-appointment-button"
        >
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <Calendar className="w-5 h-5 text-white" />
          </div>
          <span className="font-semibold text-sm">Termin vereinbaren</span>
        </button>
      </div>
    </div>
  );
};

export default MobileStickyBar;
